import { useList, useDetail, useCreate, useUpdate, useDelete, useData, useAction } from "@inmagik/react-crud"
import { Vocabolario, TipologiaVocabolario, TipolologiaVocabolarioList } from "../types"
import { API_URL } from "../constants"

export function useVocabolariList(params: Record<string, string> = {}) {
  return useList<Vocabolario>(`${API_URL}/vocabolari`, {
    query: params,
  })
}

export function useVocabolariTipologieList() {
  return useData<TipologiaVocabolario[]>(`${API_URL}/vocabolari/vocabolari`)
}

export function useVocabolariListWithTipologie(params: Record<string, string> = {}) {
  return useData<TipolologiaVocabolarioList[]>(`${API_URL}/vocabolari/vocabolari-list`, {
    query: params,
  })
}

export function useVocabolario(id: number | undefined | string) {
  return useDetail<Vocabolario>(`${API_URL}/vocabolari`, id?.toString())
}

export function useVocabolarioCreate() {
  return useCreate<Vocabolario>(`${API_URL}/vocabolari`)
}

export function useVocabolarioUpdate() {
  return useUpdate<Vocabolario>(`${API_URL}/vocabolari`)
}

export function useVocabolarioDelete() {
  return useDelete<Vocabolario>(`${API_URL}/vocabolari`)
}

export function useUnificatVocabolari() {
  return useAction<void, { vocabolario_da_mantenere: string; vocaboli_da_eliminare: string[] }>(`${API_URL}/vocabolari/unifica`, {
    method: "POST",
  })
}

